import {
  SingleMemberFirmCreationType,
  SingleMemberFirmPricingPackage,
} from '@bupa-kkv/features/company-creation/types';
import { useMutation } from '@tanstack/react-query';
import { submitPricingOffer } from '../../api/self-employment/submit-pricing-offer';
import { PackageIds } from './get-pricing-packages.query';

export const useSubmitPricingOffer = () => {
  return useMutation({
    mutationFn: ({
      pricingPackage,
      type,
      couponCode,
    }: {
      pricingPackage: SingleMemberFirmPricingPackage;
      type: SingleMemberFirmCreationType;
      couponCode?: string;
    }) =>
      submitPricingOffer({
        packageId: PackageIds[type][pricingPackage],
        couponCode,
      }),
  });
};
